import { parseCommaSeparatedValues } from './stringUtils';

export function normalizeTags(tag) {
    if (!tag) return '';

    const normalized = String(tag).toLowerCase();

    if (normalized === 'apis') return 'APIs';
    if (normalized === 'api') return 'API';
    if (normalized === 'dotcms') return 'dotCMS';
    if (normalized === 'dotcms features') return 'dotCMS Features';

    return String(tag)
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\bapi(s)?\b/gi, (_, s) => `API${s ? 's' : ''}`)
        .replace(/\b[a-z]/g, (c) => c.toUpperCase());
}

export function normalizeTagList(tags) {
    if (!tags) return [];

    return parseCommaSeparatedValues(tags).map((t) => normalizeTags(t));
}
